<template>
  <TeamMembers />
</template>

<script setup>
import TeamMembers from '@/components/teams/TeamMembers.vue'
</script> 